import {getSidebarWidth} from '@map/sidebars';
import {Snackbar, SnackbarProps} from '@mui/material';

const DEFAULT_DURATION = 3500;
const SIDEBAR_WIDTH = getSidebarWidth();

interface SidebarInteractionSnackbarProps extends SnackbarProps {
    mapControlsOffset: number;
}

export default function SidebarInteractionSnackbar({
    mapControlsOffset,
    ...props
}: SidebarInteractionSnackbarProps) {
    // If a duration is not provided, the snackbar will automatically hide
    // itself after 3500ms. A duration of null means the sidebar should not hide.
    const autoHideDuration =
        props.autoHideDuration === undefined ? DEFAULT_DURATION : props.autoHideDuration;

    return (
        <Snackbar
            ContentProps={{
                style: {
                    fontSize: 14,
                    width: 252,
                    minWidth: 252,
                    margin: '0 auto',
                },
            }}
            anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
            message={props.message}
            open={props.open}
            onClose={props.onClose}
            sx={{
                left: {xs: mapControlsOffset},
                width: `${SIDEBAR_WIDTH}px`,
            }}
            {...props}
            autoHideDuration={autoHideDuration}
        />
    );
}
